<div class="project-form-panel" *ngIf="isVisible">
  <div class="panel-overlay" (click)="close()"></div>
  <div class="panel-container">
    <!-- Header -->
    <div class="panel-header">
      <div class="header-label">New Project</div>
      <div class="header-actions">
        <button class="close-button" (click)="close()" aria-label="Close panel">
          <img src="./assets/images/close.svg">
        </button>
      </div>
    </div>

    <!-- Body -->
    <div class="panel-content">
      <!-- Tabs -->
      <div class="tab-header">
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'blank'"
          (click)="changeTab('blank')"
          type="button">
          Create New Project
        </button>
        <button 
          class="tab-button" 
          [class.active]="activeTab === 'clone'"
          *ngIf="canShowCloneTab"
          (click)="changeTab('clone')"
          type="button">
          Clone Existing Project
        </button>
      </div>

      <!-- Tab Content -->
      <div class="tab-content-wrapper">
        <!-- Blank Project Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'blank'">
          <app-create-blank-project
            (projectCreated)="onProjectCreated($event)"
            (cancel)="onCancel()">
          </app-create-blank-project>
        </div>

        <!-- Clone Project Tab -->
        <div class="tab-pane" *ngIf="activeTab === 'clone'">
          <app-clone-existing-project
            (projectCloned)="onProjectCloned($event)"
            (cancel)="onCancel()">
          </app-clone-existing-project>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="panel-footer">
      <button type="button" class="btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="btn-save" [disabled]="!canSubmit()" (click)="submit()">Create</button>
    </div>
  </div>
</div>
